var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#C6DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2505 19.853C27.2505 18.8905 26.463 18.103 25.5005 18.103C24.538 18.103 23.7505 18.8905 23.7505 19.853V21.603H27.2505V19.853Z",
    fill: "#1A2CCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.3531V23.3531C15 30.6156 18.85 32.8031 24.1 35.7781L25.0625 36.3031C25.2375 36.4781 25.325 36.4781 25.5 36.4781C25.675 36.4781 25.7625 36.4781 25.9375 36.3906L26.9 35.8656C32.15 32.8031 36 30.6156 36 23.3531V16.3531C36 16.0031 35.7375 15.6531 35.3875 15.5656L25.7625 12.0656C25.5875 11.9781 25.325 11.9781 25.15 12.0656L15.525 15.5656C15.2625 15.6531 15 16.0031 15 16.3531ZM20.25 24.2281C20.25 23.0906 20.95 22.1281 22 21.7781V19.8531C22 17.9281 23.575 16.3531 25.5 16.3531C27.425 16.3531 29 17.9281 29 19.8531V21.7781C30.05 22.1281 30.75 23.0906 30.75 24.2281V26.8531C30.75 29.7406 28.3875 32.1031 25.5 32.1031C22.6125 32.1031 20.25 29.7406 20.25 26.8531V24.2281Z",
    fill: "#1A2CCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 24.228C24.975 24.228 24.625 24.578 24.625 25.103V26.853C24.625 27.378 24.975 27.728 25.5 27.728C26.025 27.728 26.375 27.378 26.375 26.853V25.103C26.375 24.578 26.025 24.228 25.5 24.228Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.5cb7cb808c436e60a00f7a61b4cbf934.svg";
export { ForwardRef as ReactComponent };